/**
 * Client-side search filter over the already-fully-fetched, real org tree
 * (Prompt 137) - never a server round-trip (the tree is already loaded in
 * full, up to the same 100-row-per-tier cap the KPI strip itself is honest
 * about). If a Super Agent's own name/code matches, its entire real subtree
 * stays visible (a matched parent's children are never hidden); otherwise
 * only PLCs/Agents that themselves match, or contain a matching descendant,
 * survive - so a search for an Agent's name still shows its real parent PLC
 * and Super Agent for context, never an orphaned node with no ancestry.
 */
function matchesQuery(name, code, query) {
  return (name ?? "").toLowerCase().includes(query) || (code ?? "").toLowerCase().includes(query);
}

export function filterOrgTree(tree, search) {
  const query = (search ?? "").trim().toLowerCase();
  if (!query) {
    return tree;
  }

  const filtered = [];
  for (const superAgent of tree) {
    const superAgentMatches = matchesQuery(superAgent.displayName, superAgent.superAgentCode, query);

    const plcs = [];
    for (const plc of superAgent.plcs) {
      const plcMatches = superAgentMatches || matchesQuery(plc.displayName, plc.plcCode, query);
      const agents = plcMatches ? plc.agents : plc.agents.filter((agent) => matchesQuery(agent.displayName, agent.agentCode, query));

      if (plcMatches || agents.length > 0) {
        plcs.push({ ...plc, agents });
      }
    }

    if (superAgentMatches || plcs.length > 0) {
      filtered.push({ ...superAgent, plcs });
    }
  }

  return filtered;
}
